"use client";

import { Wrench, Lightbulb, Droplet, Paintbrush, Layers } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  icon: Wrench,
  title: "Kitchen & Bathroom Remodeling",
  description: "Full renovation services including cabinets, countertops, flooring, and fixtures."
}, {
  icon: Lightbulb,
  title: "Electrical & Lighting",
  description: "Safe and efficient electrical upgrades, new installations, and recessed lighting."
}, {
  icon: Droplet,
  title: "Plumbing & Fixtures",
  description: "Expert plumbing installation for sinks, faucets, showers, and appliances."
}, {
  icon: Paintbrush,
  title: "Painting & Finishing",
  description: "Interior walls, ceilings, moldings, and stairs with premium Sherwin Williams paint."
}, {
  icon: Layers,
  title: "Flooring Installation",
  description: "Vinyl planks, hardwood, and other flooring options with moisture protection."
}];
export default function ServicesPreview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={sectionRef} className="py-20 bg-background">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-display font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive renovation and construction solutions for your home or business
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`hover-lift border border-border ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-display font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}